import React, {
    useRef, useMemo, useEffect, useContext,
} from 'react';
import classNames from 'classnames';
import { useReactiveVar } from '@apollo/client';
import { DishesSelectionContext } from 'app/containers/contexts/dishesSelection.context';
import { analyticService } from 'global/services';
import { selectedPeriodVar } from 'app/apollo/reaction';
import { isBannerPeriodActive } from 'app/utils/bannerPeriod';
import css from './specialBanners.module.scss';

import hochlandM from './assets/hochland.m.png';
import hochlandL from './assets/hochland.d.png';
import bakeM from './assets/bake.m.png';
import bakeL from './assets/bake.d.png';
import greenM from './assets/_green.m.png';
import gryadkaM from './assets/gryadka.m.png';
import greenL from './assets/_green.d.png';
import kidsM from './assets/_kids.m.png';
import kidsL from './assets/_kids.d.png';
import guestsM from './assets/_guest.m.png';
import guestsL from './assets/_guest.d.png';

import hitsM from './assets/hits.m.png';
import hitsL from './assets/hits.d.png';

import speedM from './assets/_hits.m.png';
import speedL from './assets/_speed.d.png';

import zapasL from './assets/_zapas.d.png';
import zapasM from './assets/_zapas.m.png';
import squidgameM from './assets/squidgame.m.png';
import dachaM from './assets/dacha.m.png';

import filmM from './assets/film.m.png';
import filmL from './assets/film.d.png';

import nyM from './assets/ny.m.png';
import nyL from './assets/ny.d.png';

import hpM from './assets/hp.m.png';
import hpL from './assets/hp.d.png';

import halloweenM from './assets/halloween.m.png';

const specialElements = [
    {
        id: 'gryadka',
        title: 'С грядки',
        subtitle: 'из деревни',
        tag: 'gryadka',
        backgroundImagePath: gryadkaM,
        periods: ['2026-08-31', '2026-09-07'],
    },
    {
        id: 'green',
        title: 'Green',
        subtitle: 'меню',
        tag: '1220',
        backgroundImagePath: greenM,
    },
    {
        id: 'guests',
        title: 'К приходу',
        subtitle: 'гостей',
        tag: 'guests',
        backgroundImagePath: guestsM,
    },
    {
        id: 'speed',
        title: 'Блюда',
        subtitle: 'за 15 минут',
        tag: '1809',
        backgroundImagePath: speedM,
        periods: ['2026-09-14'],
    },
    {
        id: 'kids',
        title: 'Детское',
        subtitle: 'меню',
        tag: 'kids',
        backgroundImagePath: kidsM,
    },
    // {
    //     id: 'ny',
    //     title: 'Новый год',
    //     subtitle: '',
    //     href: '/blyuda-dlya-novogodnego-stola/',
    //     backgroundImagePath: nyM,
    // },
    // {
    //     id: 'halloween',
    //     title: 'Бокс',
    //     subtitle: 'на Хэллоуин',
    //     href: '/halloween',
    //     backgroundImagePath: halloweenM,
    // },
    // {
    //     id: 'hp',
    //     title: 'Меню',
    //     subtitle: 'из Хогвартса',
    //     href: '/hp',
    //     backgroundImagePath: hpM,
    // },
    // {
    //     id: 'film',
    //     title: 'Дома',
    //     subtitle: 'как в кино',
    //     tag: 'film',
    //     backgroundImagePath: filmM,
    // },
    // {
    //     id: 'squidgame',
    //     title: 'Игра',
    //     subtitle: 'в кальмара',
    //     tag: 'squidgame',
    //     backgroundImagePath: squidgameM,
    // },
    // {
    //     id: 'dacha',
    //     title: 'На дачу',
    //     subtitle: '',
    //     href: '/dacha',
    //     backgroundImagePath: dachaM,
    // },
    // {
    //     id: 'sweet',
    //     title: 'Печём',
    //     subtitle: 'вместе',
    //     href: '/sweet',
    //     backgroundImagePath: bakeM,
    // },
    // {
    //     id: 'zapas',
    //     title: 'Про',
    //     subtitle: 'запас',
    //     href: '/nz/',
    //     backgroundImagePath: zapasM,
    // },
    // {
    //     id: 'hits',
    //     title: 'Хиты',
    //     subtitle: 'вне времени',
    //     tag: 'hits',
    //     backgroundImagePath: hitsM,
    // },
    // {
    //     id: 'hits',
    //     title: 'Хиты',
    //     subtitle: 'вне времени',
    //     tag: 'hits',
    //     backgroundImagePath: hitsM,
    // },
];

const SpecialBannerItem = ({ el }) => (
    <div className={css.specilaBlockCardContent}>
        <div className={css.specilaBlockCardLeft}>
            <div className={css.specilaBlockCardTitle}>
                {el.title}
                <br />
                {el.subtitle}
            </div>
        </div>
        <div className={css.specilaBlockCardRight}>
            <img
                src={el.backgroundImagePath}
                alt={el.backgroundImagePath}
                className={css.specilaBlockCardImg}
            />
        </div>
    </div>
);

const SpecialBanners = ({ ids = '', specialsAncor, isV2 }) => {
    const sectionRef = useRef(null);
    const { onOpenSelection } = useContext(DishesSelectionContext);
    const selectedPeriod = useReactiveVar(selectedPeriodVar);

    const scrollToMiddle = () => {
        if (sectionRef.current) {
            const element = sectionRef.current;
            const elementRect = element.getBoundingClientRect();
            const absoluteElementTop = window.pageYOffset + elementRect.top;
            const elementMiddle = absoluteElementTop + elementRect.height / 2;

            const windowMiddle = window.innerHeight / 2;

            // Скроллим так, чтобы середина элемента была в середине окна
            window.scrollTo({
                top: elementMiddle - windowMiddle,
                behavior: 'smooth',
            });
        }
    };

    useEffect(
        () => {
            const specialsAncorValue = sessionStorage.getItem('specialsAncor');
            if (specialsAncorValue === specialsAncor) {
                scrollToMiddle();
                sessionStorage.removeItem('specialsAncor');
            }
        },
        [specialsAncor],
    );

    const rootClasses = classNames({
        [css.specialSPABlockRoot]: true,
        [css.trackableMainBlock]: true,
        [css['mobile-only']]: true,
        [css.v2]: isV2,
    });
    const filteredItemsArray = useMemo(
        () => {
            const order = ids.split('.');

            const all = specialElements
                .filter((el) => order.includes(el.id))
                .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));

            const alwaysAvailable = all.filter((el) => !el.periods);
            const periodBanners = all.filter((el) => el.periods);

            const matchedPeriodBanners = periodBanners.filter(
                (el) => isBannerPeriodActive(el.periods, selectedPeriod),
            );

            return [...matchedPeriodBanners, ...alwaysAvailable];
        },
        [ids, selectedPeriod],
    );
    return (
        <div
            ref={sectionRef}
            className={rootClasses}
            data-header_name="Collections"
            aria-label="mobile-special-banners-area"
            data-scroll_name="Сollections_three_blocks"
        >

            {filteredItemsArray.map((el) => {
                const isSelection = Boolean(el.tag);
                const CardContent = (
                    <div className={css.specilaBlockCardContent}>
                        <div className={css.specilaBlockCardLeft}>
                            <div className={`body-l-medium ${css.specilaBlockCardTitle}`}>
                                {el.title}
                                <br />
                                {el.subtitle}
                            </div>
                        </div>
                        <div className={css.specilaBlockCardRight}>
                            <img
                                src={el.backgroundImagePath}
                                alt={el.title} // Лучше использовать title, а не путь
                                className={css.specilaBlockCardImg}
                                loading="lazy" // Добавьте lazy loading
                            />
                        </div>
                    </div>
                );

                const handleCardClick = (banner_name) => {
                    analyticService.push({
                        eventName: 'Collection_Click',
                        banner_name,
                        source_name: 'menu',
                    });
                    sessionStorage.setItem('specialsAncor', specialsAncor);
                };

                const handleSelectionClick = () => {
                    onOpenSelection({ tag: el.tag });
                };

                return (
                    <div
                        className={css.specilaBlockCardsTitleList}
                        key={el.backgroundImagePath} // Лучше использовать уникальный id
                        onClick={() => handleCardClick(el.id)}
                        role="none"
                    >
                        {isSelection ? (
                            <div onClick={handleSelectionClick} role="none">
                                <div className={css.specilaBlockCardRoot} data-banner_name="hochland">
                                    {CardContent}
                                </div>
                            </div>
                        ) : (
                            <a href={el.href} className={css.specilaBlockCardRoot} data-banner_name="hochland">
                                {CardContent}
                            </a>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export { SpecialBanners };
